<template>
  <section>
    <div class="grid">
      <product-card
        v-for="product in products"
        :key="product.title"
        :title="product.title"
        :description="product.description"
        :icon="product.icon"
        :iconAlt="product.iconAlt"
      >
      </product-card>
    </div>
  </section>
</template>

<script>
import { ProductCard } from "@/components";

export default {
  name: "TheProductsSection",
  data: function() {
    return {
      products: [
        {
          title: "4Note",
          icon: require("@/assets/img/4Note.png"),
          iconAlt: "4Note icon",
          description:
            'Beautiful, simple to use, <b>sticky notes widget</b> application available for free on <a href="https://play.google.com/store/apps/details?id=com.smark.fornote&hl=en" target="_blank">Google Play</a>.'
        },
        {
          title: "This Website",
          icon: require("@/assets/img/BeeBg.svg"),
          iconAlt: "This websites icon",
          description:
            'This <b>presentation website</b> written in Vue.js, with publicly available code on <a href="https://gitlab.com/sasom/my-page" target="_blank">GitLab</a>.'
        },
        {
          title: "RunFest",
          icon: require("@/assets/img/RunFest.png"),
          iconAlt: "RunFest icon",
          description:
            'Offline GPS based <b>running app</b> to improve your running skills available for free on <a href="https://play.google.com/store/apps/details?id=com.smark.runfest&hl=en" target="_blank">Google Play</a>.'
        },
        {
          title: "BeeP",
          icon: require("@/assets/img/BeeP.png"),
          iconAlt: "BeeP icon",
          description:
            'BeeP is a premium, well designed and easily operated <b>timer for interval training</b>. Early access is available at <a href="https://play.google.com/store/apps/details?id=com.smark.beep" target="_blank">Google Play</a>.'
        },
        {
          title: "Creative Website",
          icon: require("@/assets/img/Website.svg"),
          iconAlt: "Creative website icon",
          description:
            'Creative <a href="https://smark-creative.netlify.com" target="_blank">presentation website</a> written in Angular, with publicly available code on <a href="https://gitlab.com/sasom/presentationpage" target="_blank">GitLab</a>.'
        },
        {
          title: "Scratch Projects",
          icon: require("@/assets/img/Scratch.svg"),
          iconAlt: "Scratch project icon",
          description:
            'Publicly available <b>games</b> made in <a href="https://scratch.mit.edu/users/smdobrota/" target="_blank">Scratch</a>, created for learning purposes and local workshops.'
        },
        {
          title: "Drinkaton",
          icon: require("@/assets/img/Drinkaton.png"),
          iconAlt: "Drinkaton icon",
          description:
            '<b>Drinking game</b> based on randomly generated numbers available for free on <a href="https://play.google.com/store/apps/details?id=smark.drinkatron&hl=en" target="_blank">Google Play</a>.'
        },
        {
          title: "PictureOCD",
          icon: require("@/assets/img/PictureOCD.png"),
          iconAlt: "Thumbnail of the game",
          description:
            '<b>Minigame</b> made in colaboration with Luka Horvat in one afternoon, for Global Game Jam 2020 theme "REPAIR". Game is available on <a href="https://sm4rk.itch.io/picture-ocd" target="_blank">Itch.io</a>.'
        }
      ]
    };
  },
  components: {
    ProductCard
  }
};
</script>

<style lang="scss" scoped>
@import "@/variables";

$content-max-width: 1420px;
$card-min-width: 18rem;
$card-gap: 6rem;

section {
  .grid {
    display: grid;

    justify-items: center;

    gap: $card-gap;

    grid-template-columns: 1fr;

    width: 100%;
    max-width: $content-max-width;
  }

  @media screen and (min-width: $screen-s) {
    .grid {
      grid-template-columns: repeat(auto-fit, minmax($card-min-width, 1fr));
    }
  }
}
</style>
